import styled from "styled-components";

// Styled Components
export const Container = styled.div`
  width: 100%;

  @media (max-width: 768px) {
    display: flex;
  }
`;
export const Icon = styled.div`
  img {
    width: 6vw;
    height: auto;
  }

  @media (max-width: 768px) {
    img {
      width: 50px;
      height: auto;
    }
  }
`;

export const Nav = styled.ul`
  display: flex;
  list-style-type: none;
  justify-content: space-between;
  /* overflow-x: scroll; */
  /* overflow-y: hidden; */
  padding: 0;
  margin: 0;
  /* flex-wrap: wrap; */
  /* border-bottom: 1px solid #a1a1a1; */
  /* width: 100px; */

  @media (max-width: 768px) {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    /* background-color: red; */
  }
`;

export const NavItem = styled.li`
  /* margin: -0.5px; */
  /* width: 100%; */
  flex: 1 1 100%;
  /* background: #a8a8a8; */
`;

export const NavButton = styled.button`
  height: 100%;
  width: 100%;
  background: none;
  border: 0;
  border-bottom: 1px solid #a1a1a1;
  padding: .5em 0;
  /* border-radius: 100px 100px 0 0; */
  border-radius: 10px 10px 0 0;
  font-size: clamp(12px, 1.4vw, 3em);
  cursor: pointer;
  color: ${({ isActive }) => (isActive ? "#38041d" : "#333")};
  font-weight: ${({ isActive }) => (isActive ? "500" : "300")};
  position: relative;
  font-family: ${(props) =>
    props.lang === "fa" ? "Tanha, sans-serif" : "Purisa, sans-serif"};

  &:disabled {
    color: #aaa;
    cursor: not-allowed;
  }

  ${({ isActive }) =>
    isActive
      ? `
      border: 1px solid #a1a1a1;
      border-bottom: none;
      background: #fff;
      `
      : `
      opacity:.6;
      `}

  @media (max-width: 768px) {

    padding: 1em;
    border-radius: 10px 0 0 10px;
    border: 0;
    border-right: 1px solid #a1a1a1; //#############
    
    
    ${({ isActive, lang }) =>
    !isActive && lang === "fa" &&
    `
    border-right: 0;
    border-left: 1px solid #a1a1a1;
    border-radius: 0 0 0 0;
    `
  }


   
  ${({ isActive }) =>
    isActive &&
    `
      border: 1px solid #a1a1a1;
      background: #fff;
      `
  }

  ${({ isActive, lang }) =>
    isActive && lang === "en" &&
    `
    border-right: none;
    `
  }



  ${({ isActive, lang }) =>
    isActive && lang === "fa" &&
    `
    border-left: none;
    border-radius: 0 10px 10px 0;
    `
  }
  }
`;

export const TabContent = styled.div`
  /* transition: all 3s ease; */

  /* border-radius: 0 0 5px 5px; */
  padding: 1em 0;
  /* background-color: red; */
  /* margin-top: -10px; */
  @media (max-width: 768px) {
    padding: 1em;
    flex: 0 1 auto;
    border-top: 1px solid #a1a1a1;
  }
`;

export const TabPane = styled.div`
  /* display: ${({ isActive }) => (isActive ? "block" : "none")}; */

  /* color: #333; */
  /* padding: 20px; */
  opacity: ${({ isActive }) => (isActive ? 1 : 0)};
  transform: ${({ isActive }) =>
    isActive ? "translateY(0)" : "translateY(5px)"};
  transition: opacity 0.4s ease, transform 0.4s ease;
  position: ${({ isActive }) => (isActive ? "relative" : "absolute")};
  visibility: ${({ isActive }) => (isActive ? "visible" : "hidden")};

  h4 {
    font-family: ${(props) =>
    props.lang === "fa" ? "Tanha, sans-serif" : "Purisa, sans-serif"};
    font-size: clamp(20px, 2.2vw, 5em);
    font-size: 1.8rem;
    padding: 1em 0 0 0;
  }

  p {
    font-weight: 300;
    line-height: 1.8;
  }

  ul {
    list-style: none;
    /* margin-top: 1rem; */
    padding-left: 0;
    /* border: 1px solid #e0e0e0; */
    /* border-radius: 8px; */
    /* background-color: #f9f9f9; */
    /* padding: 1rem 0; */
  }

  /* li {

  } */

  li span {
    margin-left: 10px;
    /* color: #333; */
    font-weight: bold;
    
  }
  /* width: 100%; */
`;
